/** Normaliza para busca: sem acentos e em minúsculas ("São" → "sao"). Mantém o comprimento. */
export function normalizarBusca(texto: string): string {
  return texto
    .replace(
      /./gsu,
      (c) =>
        c
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .charAt(0) || c,
    )
    .toLowerCase();
}

export interface Trecho {
  texto: string;
  destaque: boolean;
}

/** Divide o rótulo em trechos, marcando a 1ª ocorrência do termo (ignorando acento/caixa). */
export function trechosDestacados(rotulo: string, termo: string): Trecho[] {
  const alvo = normalizarBusca(termo.trim());
  const indice = alvo ? normalizarBusca(rotulo).indexOf(alvo) : -1;
  if (indice < 0) return [{ texto: rotulo, destaque: false }];
  const fim = indice + alvo.length;
  return [
    { texto: rotulo.slice(0, indice), destaque: false },
    { texto: rotulo.slice(indice, fim), destaque: true },
    { texto: rotulo.slice(fim), destaque: false },
  ].filter((t) => t.texto !== '');
}

export function contemBusca(rotulo: string, termo: string): boolean {
  return normalizarBusca(rotulo).includes(normalizarBusca(termo.trim()));
}
